module.exports = __webpack_public_path__ + "rs.jpg?96011dc1067940295c5548a7ec76bc03";